import Icon from '../components/Icon.vue'

Icon.register({
  gifts: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M240.6 194.1C242.5 163.3 257.9 132.9 284.6 114.3 279.4 103.5 268.7 96 256 96H226.6L257.3 74C264.5 68.9 266.2 58.9 261 51.7L251.7 38.7C246.6 31.5 236.6 29.8 229.4 35L197.4 57.9 208.9 27.3C212 19 207.8 9.8 199.5 6.7L184.5 1.1C176.2-2 167 2.2 163.9 10.5L144 63.5 124.1 10.4C121 2.1 111.8-2.1 103.5 1L88.5 6.6C80.2 9.7 76 19 79.2 27.2L90.7 57.8 58.6 35C51.4 29.9 41.4 31.5 36.3 38.7L27 51.7C21.9 58.9 23.5 68.9 30.7 74L61.4 96H32C14.3 96 0 110.3 0 128V480C0 497.7 14.3 512 32 512H200.9C195.4 502.5 192 491.7 192 480V256C192 226.1 212.8 201 240.6 194.1zM224 480C224 497.7 238.3 512 256 512H416V384H224V480zM448 512H608C625.7 512 640 497.7 640 480V384H448V512zM608 224H587.6C590.2 216.4 592 208.5 592 200.2 592 164.7 565 128 519.9 128 471.8 128 444 175.7 432 203.3 419.9 175.7 392.1 128 344.1 128 299 128 272 164.7 272 200.2 272 208.5 273.7 216.4 276.4 224H256C238.3 224 224 238.3 224 256V352H416V224H431.3L432 223.8 432.7 224H448V352H640V256C640 238.3 625.7 224 608 224zM336 224C333.3 222.6 330.9 221 328.8 219.2 321.5 212.8 320 205.4 320 200.2 320 190.5 326.4 176 344.1 176 362.8 176 379.7 203.4 388.6 224H336zM535.2 219.2C533.1 221 530.7 222.6 528 224H475.4C484.2 203.7 501.2 176 519.9 176 537.6 176 544 190.5 544 200.2 544 205.4 542.5 212.8 535.2 219.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/gifts.js
// module id = 8hlh
// module chunks = 144